import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppService } from '../../../../../../../app/app.service';
import { CurrentSelection, Customer, Equipment, FavOperation, favPopUpModel, JobSite, SearchFavorite, SearchItem, SelectionLists } from '../../../../../../../app/entities';
import { EquipmentModel } from '../../../../../../../app/modules/manage-components/manage-components.model';
import { Router } from '@angular/router';
import { SetupEquipmentService } from '../../../../../../../app/modules/setup-equipment/setup-equipment.service';
import { NotificationsService } from 'angular2-notifications';
import { ColumnList, DisplayOptionDate, QuoteDetailResult, QuoteDetailResultVm, UcPlannerDataVM } from '../../../../../../../app/modules/setup-equipment/setup-equipment.model';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { SharedService } from '../../../../../../../app/shared/services/SharedService';
import moment from 'moment';

@Component({
  selector: 'app-display-settings-popup',
  templateUrl: './display-settings-popup.component.html',
  styleUrls: ['./display-settings-popup.component.scss']
})
export class DisplaySettingsPopupComponent implements OnInit {


  PopupFor: number;
  Month: number;
  startDate: Date;
  endDate: Date;
  interval: number = 1;
  Name: string;
  textColor: string = '#FFFFFF';
  bgColor: string = '#2F80ED';
  selectedCustomer: number;
  customerList: Customer[] = [];
  customerListFliter: Customer[] = [];
  CustomerId: number;
  customerTitle: string;
  public jobSiteList: JobSite[] = [];
  public jobSiteListFilter: JobSite[] = [];
  JobsiteId: number;
  selectedEquipment: number;
  QuoteDetail_Auto: number;
  selectedValues: any[] = [];
  Link: number;
  Bush: number;

  Shoe: number;
  Idlers: number;
  TrackRoller: number;
  CarrierRoller: number;
  Sprocket: number;
  SummaryRollingStock: number
  SummaryTrackStock: number
  Make: number;
  LastInspection: number;
  AVGDailyUse: number;
  Position: number;
  NextPmService: number;
  SecondPmService: number;
  Worn_100: number;
  Worn_120: number;
  CMU: number;
  DOC: number;
  TFrame: number;
  masterSelected: boolean;
  date: string;
  QuoteId: number;
  componentid: number;
  equipmentId: number;
  public availableColors = [
    {
      Name: 'Blue',
      Colour: '#2F80ED'
    },
    {
      Name: 'Red',
      Colour: '#EB5757'
    },
    {
      Name: 'Green',
      Colour: '#6FCF97'
    },
    {
      Name: 'White',
      Colour: '#FFFFFF'
    },
    {
      Name: 'Black',
      Colour: '#333333'
    },
    {
      Name: 'Purple',
      Colour: '#BB6BD9'
    },
    {
      Name: 'Light Blue',
      Colour: '#56CCF2'
    },
    {
      Name: 'Orange',
      Colour: '#F2994A'
    }];
  constructor(@Inject(MAT_DIALOG_DATA) private _data: any, private _planerService: SetupEquipmentService, public dialogRef: MatDialogRef<DisplaySettingsPopupComponent>,
    private _appService: AppService, private ref: ChangeDetectorRef, private _sharedService: SharedService, private router: Router, private _notify: NotificationsService,) {
    this.customerCtrl = new FormControl();
    this.jobsiteCtrl = new FormControl();
    this.equipmentCtrl = new FormControl();
  }
  filteredCustomers: Observable<Customer[]>;
  customerCtrl: FormControl;
  jobsiteCtrl: FormControl;
  equipmentCtrl: FormControl;
  favourite: any;
  favouriteId: number;
  isUpdate: boolean
  filteredJobsites: Observable<JobSite[]>;
  internalLimitedCustomers: Customer[];
  smu: number;
  ngOnInit(): void {
    this.PopupFor = this._data.PopupFor;
    this.filteredCustomers =
      this.customerCtrl.valueChanges
        .startWith(null)
        .map(customerInput => customerInput ? this.filterCustomers(customerInput) : this.resetCustomer());
    this.QuoteDetail_Auto = this._data.QuoteDetailAuto;
    this.selectedValues = this._data.selectedValues;
    this.selectedColumns = this._data.selectedColumns;

    if (this.PopupFor == 15 || this.PopupFor == 16) {
      this.favourite = this._data.Favourite;

      if (this.favourite != null) {
        this.favouriteId = this.favourite.Id;
        this.Name = this.favourite.Name;
        this.bgColor = this.favourite.BackgroundColor;
        this.textColor = this.favourite.TextColor;
        this.isUpdate = true;
      }
    }

    if (this.PopupFor == 8) {

      this._appService.getCustomerListForSelection(1, 10000).subscribe(result => {

        this.selectionLists.customerList = result;

        this.internalLimitedCustomers = result; this.customerCtrl.reset();

        this._appService.getJobSiteListForSelection(1, 10000).subscribe(result => {

          this.selectionLists.jobSiteList = result;
          this.internalLimitedJobSites = result; this.jobsiteCtrl.reset();
          if (this._data.customerId > 0 && this._data.jobsiteid > 0) {
            this.CustomerId = this._data.customerId
            this.JobsiteId = this._data.jobsiteid
            this.GetEquipment();
            const customertitle = this.selectionLists.customerList.find(x => x.Id == this._data.customerId).Title;
            this.customerCtrl.setValue(customertitle)

            const jobtitle = this.selectionLists.jobSiteList.find(x => x.Id == this._data.jobsiteid).Title;
            this.jobsiteCtrl.setValue(jobtitle)

          }
        });
      });



      this.filteredJobsites = this.jobsiteCtrl.valueChanges
        .startWith(null)
        .map(jobsiteInput => jobsiteInput ? this.filterJobsites(jobsiteInput) : this.resetJobsite());

    }
    this.ref.detectChanges();


    if (this.PopupFor == 4) {
      if (!this.selectedValues || this.selectedValues.length === 0) {

      } else {
        this.selectedValues.forEach(x => {
          if (x == 230) {
            this.Link = x;
          } else if (x == 231) {
            this.Bush = x;
          } else if (x == 232) {
            this.Shoe = x;
          }
          else if (x == 233) {
            this.Idlers = x;
          }
          else if (x == 234) {
            this.CarrierRoller = x;
          }
          else if (x == 235) {
            this.TrackRoller = x;
          }
          else if (x == 236) {
            this.Sprocket = x;
          }
          else if (x == 101) {
            this.SummaryRollingStock = x;
          }
          else if (x == 102) {
            this.SummaryTrackStock = x;
          } else if (x == 103) {
            this.TFrame = x;
          }
        })
        if (this.selectedValues.length == 10) {
          this.masterSelected = true;
        }

      }
    } else if (this.PopupFor == 1) {

      this.ColumnList.AVGDailyUse = this.selectedColumns.AVGDailyUse;
      this.ColumnList.CMU = this.selectedColumns.CMU;
      this.ColumnList.DOC = this.selectedColumns.DOC;
      this.ColumnList.Make = this.selectedColumns.Make;
      this.ColumnList.NextPmService = this.selectedColumns.NextPmService;
      this.ColumnList.SecondPmService = this.selectedColumns.SecondPmService;
      this.ColumnList.LastInspection = this.selectedColumns.LastInspection;
      this.ColumnList.Worn_100 = this.selectedColumns.Worn_100;
      this.ColumnList.Worn_120 = this.selectedColumns.Worn_120;
    }

    if (this.PopupFor == 112) {
      this.equipmentId = this._data.equipmentId;
      this.componentid = this._data.componentid;
      this.date = this._data.date;
      this.QuoteId = this._data.QuoteId;
      this.smu = this._data.smu;
      this.GetComponnetREcomendation();
    }

    if (this.PopupFor == 2) {

      this.GetUserDateS();

    }
  }
  selectionLists: SelectionLists = new SelectionLists();
  JobSiteforFleetconfiguration: JobSite = new JobSite()
  //equipmentCtrl: FormControl;
  selectedJobsiteForInput: JobSite = new JobSite();
  customerSelected(selected, input) {
    // console.log('customerSelected', selected);
    debugger;


    this.selectedJobsiteForInput.CustomerId = selected.option.value.Id
    this.currentSelection.customer.Id = selected.option.value.Id;
    this.currentSelection.customer.Title = selected.option.value.Title;
    //fleet configuration filter
    this.JobSiteforFleetconfiguration.CustomerId = selected.option.value.Id;
    //this._sharedService.setCustomerInfo(this.JobSiteforFleetconfiguration);
    this.pushMultipleSelection(1, selected.option.value.Id, selected.option.value.Title);
    this.internalLimitedJobSites = this.selectionLists.jobSiteList.filter(jobsite =>
      this.multipleSelections.findIndex(m => m.Id === 1 && (jobsite.CustomerId === m.SearchId)) >= 0);

    this.customerCtrl.reset();
    this.customerCtrl.setValue(selected.option.value.Title)
  }
  resetJobsite(): JobSite[] {
    this.currentSelection.jobSite = new JobSite();
    if (!this.internalLimitedJobSites) return [];

    this.equipmentCtrl.reset();
    return this.internalLimitedJobSites.filter(jobsite =>
      (this.multipleSelections.findIndex(m => m.Id === 2 && (m.SearchId === jobsite.Id || m.SearchStr.toLowerCase() === jobsite.Title.toLowerCase())) < 0)
    );
  }

  pushMultipleSelection(itemId: number, searchId: number, searchText: string): void {

    if ((searchId === 0 && searchText.length === 0))
      return;
    console.log('itemId ' + itemId + '  search Id ' + searchId + ' searvh text ' + searchText)
    const currentSearchItem = this._appService.getSearchItems().find(m => m.Id === itemId);
    if (!currentSearchItem) return;

    // If the item isn't a date
    if (itemId !== 12 && itemId !== 13 && itemId !== 22 && itemId !== 23) {
      const index = this.multipleSelections.findIndex(m => m.Id === itemId && (m.SearchId === searchId || m.SearchStr.toLowerCase() === searchText.toLowerCase()));
      if (index >= 0 && itemId !== 20) return;
    } else if (itemId == 22) {
      this.multipleSelections = this.multipleSelections.filter(x => x.Id != 22);
    }
    else if (itemId == 23) {
      this.multipleSelections = this.multipleSelections.filter(x => x.Id != 23);
    }
    else {
      const index = this.multipleSelections.findIndex(m => m.Id === itemId);
      this.multipleSelections.splice(index, 1);
    }
    const item = new SearchItem();
    item.Id = itemId; item.SearchId = searchId; item.SearchStr = searchText; item.Title = searchText;

    if (itemId == 1) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    } else if (itemId == 2) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    } else if (itemId == 4) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    } else if (itemId == 5) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    }
    else {
      this.multipleSelections.push(item);
    }


    console.log("this.multiple__", this.multipleSelections, item)
  }
  internalLimitedEquipments: Equipment[];
  filteredEquipments: Observable<Equipment[]>;
  jobsiteSelected(selected, input) {
    // console.log('jobsiteSelected', selected);
    debugger


    this.selectedJobsiteForInput.Id = selected.option.value.Id
    this.currentSelection.jobSite.Id = selected.option.value.Id;
    this.currentSelection.jobSite.Title = selected.option.value.Title;
    this.pushMultipleSelection(2, selected.option.value.Id, selected.option.value.Title);
    this.JobSiteforFleetconfiguration.Id = selected.option.value.Id
    this._sharedService.setCustomerInfo(this.JobSiteforFleetconfiguration);

    this.internalLimitedEquipments = this.selectionLists.equipmentList.filter(equipment =>
      this.multipleSelections.findIndex(m => m.Id === 2 && (equipment.JobSiteId === m.SearchId)) >= 0);
    this.filteredEquipments = Observable.of(this.internalLimitedEquipments);

    var customerData = this.multipleSelections.find(x => x.Id == 1);
    let customerid = 0;
    if (customerData != null) {
      customerid = customerData.SearchId;
      this.CustomerId = customerid
    }

    var jobSiteData = this.multipleSelections.find(x => x.Id == 2);
    let jobsiteid = 0;
    if (jobSiteData != null) {
      jobsiteid = jobSiteData.SearchId;
      this.JobsiteId = jobsiteid;
    }

    // this._appService.getFamilyList(customerid.toString(), jobsiteid.toString()).subscribe(result => {
    //   this.selectionLists.familyList = this.filterMakeModelFamilyForExistingOnly ?
    //     result.filter(m => m.ExistingCount > 0) : result; this.familyCtrl.reset();
    // });



    this.jobsiteCtrl.reset();
    this.jobsiteCtrl.setValue(selected.option.value.Title);

    this.GetEquipment();
  }
  @ViewChild('autoCompleteCustomer', { read: MatAutocompleteTrigger })
  customerTrigger: MatAutocompleteTrigger;
  @ViewChild('jobSiteAutoCompleteInput', { read: MatAutocompleteTrigger })
  jobSiteTrigger: MatAutocompleteTrigger;
  @ViewChild('equipmentAutoCompleteInput', { read: MatAutocompleteTrigger })
  equipmentTrigger: MatAutocompleteTrigger;
  focus(item) {
    switch (item) {
      case 1:
        this.customerTrigger.openPanel();
        break;
      case 2:
        this.jobSiteTrigger.openPanel();
        break;
      case 3:
        this.equipmentTrigger.openPanel();
        break;

    }
  }
  filterCustomers(userText: any) {
    // console.log('filterCustomers', userText);
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;
    return this.selectionLists.customerList.filter(cust =>
      cust.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
    );
  }
  internalLimitedJobSites: JobSite[];
  filterJobsites(userText: any) {
    // console.log('filterJobsites', userText);
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;
    return this.internalLimitedJobSites.filter(jobsite =>
      jobsite.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
    );
  }
  currentSelection: CurrentSelection = new CurrentSelection();
  multipleSelections: SearchItem[] = [{ Id: 8, SearchId: 1, SearchStr: "", Title: "Evaluation A" }, { Id: 9, SearchId: 1, SearchStr: "", Title: "Evaluation B" }, { Id: 10, SearchId: 1, SearchStr: "", Title: "Evaluation C" }, { Id: 11, SearchId: 1, SearchStr: "", Title: 'Evaluation X' }];
  resetCustomer(): Customer[] {
    // console.log('resetCustomer');
    this.currentSelection.customer = new Customer();
    this.internalLimitedJobSites = this.selectionLists.jobSiteList.filter(jobsite =>
      this.multipleSelections.findIndex(m => m.Id === 1 && (jobsite.CustomerId === m.SearchId)) >= 0);
    this.jobsiteCtrl.reset();

    // return this.selectionLists.customerList.filter(cust =>
    //     (this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr.toLowerCase() === cust.Title.toLowerCase())) < 0)
    // );

    if (this.multipleSelections.filter(m => m.Id === 21).length === 0)
      return this.selectionLists.customerList.filter(cust => this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr === cust.Title)) < 0);

    if (this.multipleSelections.filter(m => m.Id === 21).length > 0)
      return this.selectionLists.customerList.filter(cust =>
        this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr === cust.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 21 && (m.SearchId === cust.DealerId)) >= 0);

    return this.selectionLists.customerList.filter(cust =>
      this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr === cust.Title)) < 0
      && this.multipleSelections.findIndex(m => m.Id === 21 && (m.SearchId === cust.DealerId)) >= 0);


  }
  @ViewChild('equipmentSelect') equipmentSelect!: MatSelect;

  onNoClick() {
    this.dialogRef.close(false);
  }

  IntervelClose() {
    this.dialogRef.close(this.interval);
  }

  onInputFocusOut() {
    if (this.startDate) {
      if (this.startDate && this.Month) {
        let newDate = new Date(this.startDate);
        const currentDay = newDate.getDate();

        // Add the dynamic number of months
        newDate.setMonth(newDate.getMonth() + this.Month);

        // Adjust for day overflow (if the new month has fewer days)
        if (newDate.getDate() < currentDay) {
          newDate.setDate(0); // Moves to the last valid date of the previous month
        }

        this.endDate = newDate;
        console.log(`Updated Date (+${this.Month} months):`, this.endDate);
      }
    }
  }

  customerChanged(event: any) {
    if (event.target.value != "") {
      const filterValue = event.target.value.toLowerCase();
      this.customerListFliter = this.customerList.filter(option => option.Title.toLowerCase().includes(filterValue));
    } else {
    }
  }
  onSelectCustomer(event: any) {
    let id = this.customerListFliter.find(f => f.Title.trim() == event.value.trim()).Id;
    this.CustomerId = id;
    this.customerTitle = event.value;
    this.jobSiteListFilter = this.jobSiteList.filter(jobsite =>
      jobsite.CustomerId == id);
    // this.autoCompleteTrigger1.writeValue('');
  }
  EquipmentModel: EquipmentModel[];
  GetEquipment() {
    this._appService.getEquipmentByCustomerJobsite(this.CustomerId, this.JobsiteId).subscribe(result => {
      this.EquipmentModel = result;
    });
  }
  UcPlannerDataVM: UcPlannerDataVM;
  GetComponnetData(SettingTypeId: number) {
    this._planerService.GetUcPlannerUserSettings(SettingTypeId).subscribe(result => {
      this.UcPlannerDataVM = result;

    });
  }
  QuoteDetailResultVm: QuoteDetailResultVm;
  QuoteDetailResult: QuoteDetailResult[] = [];
  GetComponnetREcomendation() {
    this._planerService.GetPlannerRecommendation(this.QuoteId, this.date, this.componentid).subscribe(result => {
      this.QuoteDetailResult = result.Data;
      console.log(this.QuoteDetailResult);
    });
  }
  DisplayOptionDate: DisplayOptionDate = new DisplayOptionDate();
  GetUserDateS() {
    this._planerService.GetUserPlannerDates().subscribe(result => {
      this.DisplayOptionDate = result;

      this.startDate = this.DisplayOptionDate.Sdate;
      this.endDate = this.DisplayOptionDate.Edate;
      this.Month = this.DisplayOptionDate.Month;
    });
  }

  Navigateto() {
    this.dialogRef.close(false);
    window.open('/equipment-action-recommendation/' + this.selectedEquipment, '_blank');

  }
  StatusID: number;
  SettingsType: number;
  ColumnId: number;
  Checked: boolean;

  maxSelections = 3; // Maximum number of selections allowed
  isMaxReached = false; // Flag to track if max is reached


  onCheckboxChange(item: string, isChecked: boolean) {
    if (this.selectedValues.length < 12) {
      this.masterSelected = false;
    }
    if (this.selectedValues.length == 0) {
      this.masterSelected = true;
    }
    if (isChecked) {
      this.selectedValues.push(item);
      if (item == '102') {
        this.Link = 230;
        this.selectedValues.push('230');

      } else if (item == '101') {
        this.Idlers = 233;
        this.selectedValues.push('233');
      }
    } else {
      this.selectedValues = this.selectedValues.filter(val => val !== item);

    }
  }

  CheckBoxChangeSave() {
    if (this.PopupFor == 4) {
      this.dialogRef.close(this.selectedValues);
    } else {
      this.dialogRef.close(this.ColumnList);
    }
  }

  selectedColumns: any;
  ColumnList: ColumnList = new ColumnList();

  OnColumnCheckBoxSlected(item: string, isChecked: boolean) {
    if (isChecked) {
      if (item == '1') {
        this.ColumnList.Make = isChecked;
      } else if (item == '2') {
        this.ColumnList.AVGDailyUse = isChecked;
      } else if (item == '3') {
        this.ColumnList.LastInspection = isChecked;
      } else if (item == '4') {
        this.ColumnList.Position = isChecked;
      } else if (item == '5') {
        this.ColumnList.NextPmService = isChecked;
      } else if (item == '6') {
        this.ColumnList.SecondPmService = isChecked;
      } else if (item == '7') {
        this.ColumnList.Worn_100 = isChecked;
      } else if (item == '8') {
        this.ColumnList.Worn_120 = isChecked;
      } else if (item == '9') {
        this.ColumnList.CMU = isChecked;
      } else if (item == '10') {
        this.ColumnList.DOC = isChecked;
      }
    } else {
      if (item == '1') {
        this.ColumnList.Make = isChecked;
      } else if (item == '2') {
        this.ColumnList.AVGDailyUse = isChecked;
      } else if (item == '3') {
        this.ColumnList.LastInspection = isChecked;
      } else if (item == '4') {
        this.ColumnList.Position = isChecked;
      } else if (item == '5') {
        this.ColumnList.NextPmService = isChecked;
      } else if (item == '6') {
        this.ColumnList.SecondPmService = isChecked;
      } else if (item == '7') {
        this.ColumnList.Worn_100 = isChecked;
      } else if (item == '8') {
        this.ColumnList.Worn_120 = isChecked;
      } else if (item == '9') {
        this.ColumnList.CMU = isChecked;
      } else if (item == '10') {
        this.ColumnList.DOC = isChecked;
      }
    }
  }
  SelectedAll: boolean
  toggleAll(isChecked: boolean) {
    this.SelectedAll = isChecked
    if (!isChecked) {
      this.SummaryTrackStock = 0;
      this.Link = 0;
      this.Bush = 0;
      this.Shoe = 0;
      this.SummaryRollingStock = 0;
      this.Idlers = 0;
      this.TrackRoller = 0;
      this.CarrierRoller = 0;
      this.Sprocket = 0;
      this.TFrame = 0;
      this.selectedValues = [];
      this.onCheckboxChange('101', false);
      this.onCheckboxChange('102', false);
      // this.onCheckboxChange('230', false);
      this.onCheckboxChange('231', false);
      this.onCheckboxChange('232', false);
      // this.onCheckboxChange('233', false);
      this.onCheckboxChange('234', false);
      this.onCheckboxChange('235', false);
      this.onCheckboxChange('236', false);
      this.onCheckboxChange('103', false);
    } else {
      this.SummaryTrackStock = 1;
      this.Link = 1;
      this.Bush = 1;
      this.Shoe = 1;
      this.SummaryRollingStock = 1;
      this.Idlers = 1;
      this.TrackRoller = 1;
      this.CarrierRoller = 1;
      this.Sprocket = 1;
      this.TFrame = 1;
      this.masterSelected = true;
      this.selectedValues.push(
        '101',
        '102',
        '230',
        '231',
        '232',
        '233',
        '234',
        '235',
        '236',
        '103'
      );


      // this.onCheckboxChange('101', true);
      // this.onCheckboxChange('102', true);
      // this.onCheckboxChange('230', true);
      // this.onCheckboxChange('231', true);
      // this.onCheckboxChange('232', true);
      // this.onCheckboxChange('233', true);
      // this.onCheckboxChange('234', true);
      // this.onCheckboxChange('235', true);
      // this.onCheckboxChange('236', true);
      // this.onCheckboxChange('103', true);
    }

    // Optionally call onCheckboxChange manually if needed
    // this.onCheckboxChange(102, false);
    // this.onCheckboxChange(230, false);
    // this.onCheckboxChange(231, false);
    // this.onCheckboxChange(232, false);
    // this.onCheckboxChange(101, false);
    // this.onCheckboxChange(233, false);
    // this.onCheckboxChange(235, false);
    // this.onCheckboxChange(234, false);
    // this.onCheckboxChange(236, false);
    // this.onCheckboxChange(103, false);
  }


  public model: SearchFavorite = new SearchFavorite();
  public operation: FavOperation = FavOperation.Add;
  submitDialog(value) {
    const result = new favPopUpModel();
    if (value == 2) {
      result.operation = FavOperation.Update;
      result.SearchFavorite.Id = this.favouriteId;
    } else if (value == 1) {
      result.operation = this.operation;
    } else {
      result.operation = FavOperation.Delete;
      result.SearchFavorite.Id = this.favouriteId;
    }
    result.SearchFavorite.BackgroundColor = this.bgColor;
    result.SearchFavorite.Name = this.Name;
    result.SearchFavorite.TextColor = this.textColor;
    result.SearchFavorite.ModuleId = 2;
    this.dialogRef.close(result);
  }

  updateFav() {
    const result = new favPopUpModel();

    result.SearchFavorite.BackgroundColor = this.bgColor;

    result.SearchFavorite.Name = this.Name;
    result.SearchFavorite.TextColor = this.textColor;
    result.SearchFavorite.ModuleId = 2;
    this.dialogRef.close(result);
  }
  SaveDate() {

    this._planerService.SavePlannerDates(moment(this.startDate).format('DD/MM/YYYY'), moment(this.endDate).format('DD/MM/YYYY')).subscribe(result => {
      if (result == 1) {
        this._notify.success('Data saved successfully!');
        this.dialogRef.close(true);
      }

    });
  }

  NavigateToAction() {

    // window.open('/product-improvement-asset/' + this.ImplementId + '/' + Id + '/' + PIPId, '_blank');
    window.open(`/equipment-action-recommendation/${this.equipmentId}/${this.smu}?actionDate=${encodeURIComponent(this.date.split('T')[0])}`, '_blank');

  }
}


